var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuestic-navbar',[_c('header-selector',{attrs:{"slot":"selector","isOpen":_vm.valueProxy},on:{"update:isOpen":function($event){_vm.valueProxy=$event},"update:is-open":function($event){_vm.valueProxy=$event}},slot:"selector"}),_c('span',{attrs:{"slot":"logo"},slot:"logo"},[_c('i',{staticClass:"fa fa-bars"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }